import { render } from "./About.vue?vue&type=template&id=71ba2ed2"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=71ba2ed2&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\kurs\\vue\\siatka-koncentracji\\siatka-koncentracji\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__